<template>
  <div>
    <mdb-card class="mb-4">
      <mdb-card-header>Team</mdb-card-header>
      <mdb-card-body v-if="error">
        <error :error="error"/>
      </mdb-card-body>
      <mdb-card-body v-if="teamData">
        <mdb-card class="mb-2 text-left"
                  v-bind:key="member.id" v-for="member in teamData.team">
          <mdb-card-body>
            <user-avatar :avatar="member.avatar" :id="member.id"
                         :memberId="member.id" :name="member.name"
                         :reputation="member.reputation" :publicView="publicView"
                         :size="50"/>
            <div>
              {{member.name}}, {{member.title}}
            </div>
          </mdb-card-body>
        </mdb-card>
        <div class="text-center" v-if="teamData.members >0">
          <b><i>Plus {{teamData.members}} {{group.memberLabel}}</i></b>
        </div>
        <div v-if="group.role != 'Public' && !publicView" class="text-center">
          <mdb-btn @click="$router.push('/group/'+group.vanityPath+'/members')"
                   rounded size="sm"
                   icon="users">Members
          </mdb-btn>
        </div>
      </mdb-card-body>
    </mdb-card>


  </div>
</template>

<script>
import error from '../common/Error'
import userAvatar from '../common/Avatar'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer} from 'mdbvue';

export default {
    name: 'teamSection',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbBtn,
      userAvatar,
      error
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      section: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        teamData: null,
        error: null,
        publicView: false
      };
    },
    mounted() {
      if (this.$route.query.viewAs == "Public") this.publicView = true
      if (!this.group) {
        return
      }
      this.teamData = this.section.data
    }
  };
</script>
